import {
  CanvasTexture,
  EquirectangularReflectionMapping,
  Fog,
  Group,
  IcosahedronGeometry,
  Mesh,
  MeshBasicMaterial,
  MeshLambertMaterial,
  Scene,
  SphereGeometry,
  SRGBColorSpace,
} from 'three';
import { HALF_CITY } from '../config/settings';
import { randFloat, randInt } from '../utils/random';

/** Gradient sky backdrop, distant fog, a sun ball and a few cartoon clouds. */
export class Sky {
  constructor(scene: Scene) {
    scene.background = createGradientTexture();
    scene.fog = new Fog(0xbfe6ff, 220, 760);

    const sun = new Mesh(new SphereGeometry(34, 24, 24), new MeshBasicMaterial({ color: 0xfff2b0 }));
    sun.position.set(420, 520, 300);
    scene.add(sun);

    for (let i = 0; i < 22; i++) scene.add(createCloud());
  }
}

function createGradientTexture(): CanvasTexture {
  const canvas = document.createElement('canvas');
  canvas.width = 8;
  canvas.height = 256;
  const ctx = canvas.getContext('2d')!;
  const grad = ctx.createLinearGradient(0, 0, 0, 256);
  grad.addColorStop(0, '#2f86dc');
  grad.addColorStop(0.55, '#69b4ee');
  grad.addColorStop(1, '#cfeaff');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, 8, 256);
  const tex = new CanvasTexture(canvas);
  tex.mapping = EquirectangularReflectionMapping;
  tex.colorSpace = SRGBColorSpace;
  return tex;
}

function createCloud(): Group {
  const cloud = new Group();
  const puffs = 3 + randInt(3);
  for (let i = 0; i < puffs; i++) {
    const puff = new Mesh(
      new IcosahedronGeometry(randFloat(10, 22), 1),
      new MeshLambertMaterial({ color: 0xffffff }),
    );
    puff.position.set(randFloat(-22, 22), randFloat(-4, 4), randFloat(-14, 14));
    cloud.add(puff);
  }
  cloud.position.set(randFloat(-HALF_CITY, HALF_CITY), randFloat(220, 360), randFloat(-HALF_CITY, HALF_CITY));
  cloud.scale.y = 0.6;
  return cloud;
}
